<div mat-menu-item class="aca-user-info" [routerLink]="['/profile']" title="{{'APP.TOOLTIPS.MY_PROFILE' | translate}}">
  <button class="aca-user-info-button">
    <div>{{ (displayName$ | async)?.initials }}</div>
  </button>
  <div class="aca-user-info-name-email">
    <div>{{ (displayName$ | async)?.firstName }}</div>
    <div>{{ (displayName$ | async)?.email }}</div>
  </div>
</div>
